
// DUCKS pattern
import { createAction, createSlice, } from "@reduxjs/toolkit";
import { set } from "react-hook-form";
const initialState = {
    loading: true,
    error: "",
    courses: [],
    allCourseList:[],
    coursesList:[],
    diagnosticList:[],
    lastPage:{
        Course:false,
        Diagnostic:false,
        all:false,
    },
    lessonPlan: {},
    current: {},
    isCurrentCourseComplete: null,
    currentAssessment: {},
    currentSession: {},
    currentChapter: {},
    pagination: {},
    nextCourse:{},
    isLast:{
        section:false,
        chapter:false
    },
    allCourseComplete : false
    // generatedQuestions:{},
};
export const courseSlice = createSlice({
    name: "course",
    initialState,
    reducers: {
        setIsLoading(state, action) {
            state.loading = action.payload;
        },
        setCourses(state, action) {
            let { data } = action.payload;
            state.courses = data;
            state.pagination = { ...action.payload, data: null };
            state.loading = false;
        },
        setCoursesList(state,action){
            let { data, type,lastPage  } = action.payload;
            if(type === "Diagnostic"){
                const existingCourses = new Map((state.diagnosticList || []).map(course => [course.id, course]));
                data.forEach(course => existingCourses.set(course.id, course));
                state.diagnosticList = Array.from(existingCourses.values());
                state.lastPage.Diagnostic = lastPage;
            }else if(type === "Course"){
                const existingCourses = new Map((state.coursesList || []).map(course => [course.id, course]));
                data.forEach(course => existingCourses.set(course.id, course));
                state.coursesList = Array.from(existingCourses.values());
                state.lastPage.Course = lastPage;
            }else{
                const existingCourses = new Map((state.allCourseList || []).map(course => [course.id, course]));
                data.forEach(course => existingCourses.set(course.id, course));
                state.allCourseList = Array.from(existingCourses.values());
                state.lastPage.Course = lastPage;
            }

            state.loading = false;
        },
         resetCoursesList(state) {
            state.coursesList = [];
            state.diagnosticList = [];
            state.allCourseList = [];
            state.lastPage = { Course: false, Diagnostic: false,all:false };
        },
        appendCourse(state, payload) {
            state.courses = [...state.courses, payload];
        },
        deleteCourse(state, action) {
            let { id } = action.payload;
            state.courses = state.courses.filter(e => e.id != id);
        },
        setCurrentCourse(state, action) {
            state.current = action.payload;
            state.loading = false;
        },
        setPrerequisites(state, action) {
            state.current = { ...state.current, prerequisites: action.payload };
        },
        setLessonPlan(state, action) {
            let { sections } = action.payload;
            if (!sections) {
                sections = [];
            }

            sections = sections.sort((a, b) => a.sequence - b.sequence).map(e => {
                let { chapters } = e;
                if (!chapters) {
                    chapters = [];
                }
                e.chapters = chapters.sort((a, b) => a.sequence - b.sequence);

                return e;
            })

            state.lessonPlan = { ...action.payload, sections }
            state.loading = false;
        },
        updateLessonPlan(state, action) {
            state.lessonPlan = { ...state.lessonPlan, ...action.payload };
        },
        setChapters(state, action) {
            let { name, chapters } = action.payload;
            let sections = state.lessonPlan?.sections || [],
                ind = sections.findIndex(e => e.name == name);

            if (ind === -1) { return; }

            state.lessonPlan.sections[ind]['chapters'] = chapters;
        },
        updateSection(state, action) {
            let section = action.payload;
            let sections = state.lessonPlan?.sections || [],
                ind = sections.findIndex(e => (e.name == section.name || e.sequence == section.sequence));

            if (ind === -1) { return; }
            let { chapters } = sections[ind];

            state.lessonPlan.sections[ind] = { ...state.lessonPlan.sections[ind], ...section, chapters };
        },
        updateChapter(state, action) {
            let { section, chapter } = action.payload;
            let sections = state.lessonPlan?.sections || [],
                ind = sections.findIndex(e => (e.name == section.name || e.sectionId == section.sectionId));

            if (ind === -1) { return; }

            let _chapters = sections[ind]['chapters'].map(e => {
                if (e?.name == chapter?.name || e?.chapterId == chapter?.chapterId) {
                    return chapter;
                }

                return e;
            });

            state.lessonPlan.sections[ind]['chapters'] = _chapters;
        },
        updateAssessments(state,action){
            const { sectionId, chapterId, assessmentId } = action.payload;
            let sections = state.lessonPlan?.sections || [];
            let sectionIndex = sections.findIndex(section => section.sectionId === sectionId);

            if (sectionIndex === -1) return; // Section not found

            let chapters = sections[sectionIndex]?.chapters || [];

            let chapterIndex = chapters.findIndex(chapter => chapter.chapterId === chapterId);

            if (chapterIndex === -1) return; // Chapter not found

            // Filter out the assessment
            let updatedAssessments = chapters[chapterIndex]?.assessments?.filter(assessment => assessment.id !== assessmentId) || [];

            // Update the Redux state
            state.lessonPlan.sections[sectionIndex].chapters[chapterIndex].assessments = updatedAssessments;
        },
        setCurrentAssessment(state, action) {
            state.currentAssessment = action.payload;
            state.loading = false;
        },
        setCurrentSession(state, action) {
            const {chapters, ...rest} = action.payload;
            state.currentSession = {...rest};
        },
        setCurrentChapter(state, action) {
            let {keyWords, ...rest} = action.payload;
            state.currentChapter = {...rest, ...{keyWords}};
        },
        setCurrentCourseComplete(state, action) {
            state.isCurrentCourseComplete = action.payload;
        },
        setNextCourse(state,action) {
            state.nextCourse = action.payload;
            state.loading =  false
        },
        setLastSection(state,action){
            state.isLast.section = action.payload;
        },
        setLastChapter(state,action){
            state.isLast.chapter = action.payload;
        },
        setAllCourseComplete(state,action){
            state.allCourseComplete = action.payload;
        },
        resetCurrentCourse(state) {
            state.current = {};
            state.lessonPlan = {};
            state.loading = true;
        }
        // setGeneratedQuestion(state,action){
        //     state.generatedQuestions = action.payload;
        //     state.loading = false;
        // }
    },
});

export const courseActions = {
    loadCourses: createAction(`${courseSlice.name}/loadCourses`, (payload) => ({ payload })),
    loadCoursesList: createAction(`${courseSlice.name}/loadCoursesList`, (payload) => ({payload})),
    loadCurrentCourse: createAction(`${courseSlice.name}/changeCurrentCourse`, (payload) => ({ payload })),
    saveCurrentCourse: createAction(`${courseSlice.name}/saveCourse`, (payload) => ({ payload })),
    createCourse: createAction(`${courseSlice.name}/createCourse`, (payload) => ({ payload })),
    removeCourse: createAction(`${courseSlice.name}/removeCourse`, (payload) => ({ payload })),
    loadLessonPlan: createAction(`${courseSlice.name}/loadLessonPlan`, (payload) => ({ payload })),
    createLessonPlan: createAction(`${courseSlice.name}/createLessonPlan`, (payload) => ({ payload })),
    deleteLessonPlan: createAction(`${courseSlice.name}/deleteLessonPlan`, (payload) => ({ payload })),
    saveCurrentLessonPlan: createAction(`${courseSlice.name}/saveLessonPlan`, (payload) => ({ payload })),
    savePrequisites: createAction(`${courseSlice.name}/savePrequisites`, (payload) => ({ payload })),
    createAssessment: createAction(`${courseSlice.name}/createAssessment`, (payload) => ({ payload })),
    deleteAssessment: createAction(`${courseSlice.name}/deleteAssessment`, (payload) => ({ payload })),
    loadCurrentAssessment: createAction(`${courseSlice.name}/changeCurrentAssessment`, (payload) => ({ payload })),
    saveCurrentAssessment: createAction(`${courseSlice.name}/saveAssessment`, (payload) => ({ payload })),
    loadNextCourse: createAction(`${courseSlice.name}/nextCourse`, (payload) => ({ payload })),
    publishAssessmentChapterToLessonPlan: createAction(`${courseSlice.name}/publishAssessmentChapterToLessonPlan`, (payload) => ({ payload })),
    publishAssessmentSectionToLessonPlan: createAction(`${courseSlice.name}/publishAssessmentSectionToLessonPlan`, (payload) => ({ payload })),
    publishAssessmentToCourse: createAction(`${courseSlice.name}/publishAssessmentToCourse`, (payload) => ({ payload })),
    // LoadGeneratedQuestions: createAction(`${courseSlice.name}/generateQuestion`, (payload) => ({ payload })),
    deleteCourse: courseSlice.actions.deleteCourse,
    updatePrerequisites: courseSlice.actions.setPrerequisites,
    updateLessonPlan: courseSlice.actions.updateLessonPlan,
    updateSection: courseSlice.actions.updateSection,
    updateChapter: courseSlice.actions.updateChapter,
    updateAssessments: courseSlice.actions.updateAssessments,
    setChapters: courseSlice.actions.setChapters,
    setCourses: courseSlice.actions.setCourses,
    setCoursesList: courseSlice.actions.setCoursesList,
    resetCoursesList: courseSlice.actions.resetCoursesList,
    setCurrentCourse: courseSlice.actions.setCurrentCourse,
    setLessonPlan: courseSlice.actions.setLessonPlan,
    appendCourse: courseSlice.actions.appendCourse,
    setCurrentAssessment: courseSlice.actions.setCurrentAssessment,
    setCurrentChapter: courseSlice.actions.setCurrentChapter,
    setCurrentSession: courseSlice.actions.setCurrentSession,
    setCurrentCourseComplete: courseSlice.actions.setCurrentCourseComplete,
    setNextCourse: courseSlice.actions.setNextCourse,
    setLastSection: courseSlice.actions.setLastSection,
    setLastChapter: courseSlice.actions.setLastChapter,
    setAllCourseComplete: courseSlice.actions.setAllCourseComplete,
    resetCurrentCourse: courseSlice.actions.resetCurrentCourse,
    // setGeneratedQuestion:courseSlice.actions.setGeneratedQuestion,
};

export const getCourses = (state) => state.course.courses;
export const getCourseList = (state) => state.course.coursesList;
export const getDiagnosticList = (state) => state.course.diagnosticList;
export const getAllCourseList = (state) => state.course.allCourseList;
export const getLastPage = (state) => state.course.lastPage;
export const getCurrentCourse = (state) => state.course.current;
export const getCurrentAssessment = (state) => state.course.currentAssessment;
export const isLoading = (state) => state.course.loading;
export const getPagination = (state) => state.course.pagination;
export const getLessonPlan = (state) => state.course.lessonPlan || {};
export const getSession = (state) => state.course.currentSession || {};
export const getChapter = (state) => state.course.currentChapter || {};
export const isCurrentCourseComplete = (state) => state.course.isCurrentCourseComplete;
export const getNextCourse = (state) => state.course.nextCourse;
export const getLastSectionChapter = (state) => state.course.isLast;
export const isAllCourseComplete = (state) => state.course.allCourseComplete;
// export const getGeneratedQuestions = (state) => state.course.generateQuestions;

export default courseSlice.reducer;
